function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../../hooks/useBreakpoint";
var ThinX = function ThinX(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.692 2.795a1.051 1.051 0 1 0-1.487-1.487L8 6.513 2.795 1.308a1.052 1.052 0 0 0-1.487 1.487L6.513 8l-5.205 5.205a1.052 1.052 0 1 0 1.487 1.487L8 9.487l5.205 5.205a1.051 1.051 0 1 0 1.487-1.487L9.487 8l5.205-5.205Z"
  }));
};
ThinX.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../../utils/breakpoint";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import IconAtm from "../../../atoms/IconAtm";
import { modalBreakpointValue, modalBackgroundColor } from "../common";
var buttonPositionMobileSpace = 2;
var buttonPositionOnMediumUpeSpace = 3;
var StyledButton = styled.button.withConfig({
  componentId: "sc-2da16t-0"
})(function (_ref) {
  var $isPositionedAbsolute = _ref.$isPositionedAbsolute,
    $hasBackground = _ref.$hasBackground,
    theme = _ref.theme;
  return css(["padding:0;border:0;background-color:transparent;cursor:pointer;", " ", ""], $isPositionedAbsolute && css(["position:absolute;top:", ";right:", ";", "{top:", ";right:", ";}"], space(buttonPositionMobileSpace), space(buttonPositionMobileSpace), breakpoint(modalBreakpointValue), space(buttonPositionOnMediumUpeSpace), space(buttonPositionOnMediumUpeSpace)), $hasBackground && css(["padding:", ";background-color:", ";border-radius:", ";", "{background-color:", ";&:hover{background-color:", ";}}"], space(1), getColor(theme, modalBackgroundColor), getBorderRadius(theme, "medium"), breakpoint("large"), getColor(theme, modalBackgroundColor, "hover"), getColor(theme, modalBackgroundColor)));
});
function CloseButtonAtm(_ref2) {
  var onClick = _ref2.onClick,
    isPositionedAbsolute = _ref2.isPositionedAbsolute,
    hasBackground = _ref2.hasBackground;
  var _useState = useState("medium"),
    _useState2 = _slicedToArray(_useState, 2),
    emphasis = _useState2[0],
    setEmphasis = _useState2[1];
  var isLargeUp = useBreakpoint("large");
  var handleMouseEnter = function handleMouseEnter() {
    return setEmphasis("high");
  };
  var handleMouseLeave = function handleMouseLeave() {
    return setEmphasis("medium");
  };
  return /*#__PURE__*/React.createElement(StyledButton, {
    onClick: onClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    $isPositionedAbsolute: !!isPositionedAbsolute,
    $hasBackground: !!hasBackground
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: ThinX,
    sizeSpace: 2,
    emphasis: isLargeUp ? emphasis : undefined
  }));
}
export default CloseButtonAtm;